export default function () {
    const phone = /^\d{11}$/;
    return { phone }
}